import { Navigate } from 'react-router-dom';

import { unwrapRoute } from '#utils/routes';

import {
    customWrapRoute,
    rootLayout,
} from './common';

const homeLayout = customWrapRoute({
    parent: rootLayout,
    path: '/',
    forwardPath: 'contentManagement',
    component: {
        render: () => import('#views/Home'),
        props: {},
    },
    context: {
        title: 'Home',
    },
});

const homeIndex = customWrapRoute({
    parent: homeLayout,
    index: true,
    component: {
        eagerLoad: true,
        render: Navigate,
        props: {
            to: '/',
            replace: true,
        },
    },
    context: {
        title: 'Home',
    },
});

const browseToolbox = customWrapRoute({
    parent: rootLayout,
    path: 'tools/',
    component: {
        render: () => import('#views/BrowseToolbox'),
        props: {},
    },
    context: {
        title: 'Tools',
    },
});

const toolDetail = customWrapRoute({
    parent: rootLayout,
    path: 'tools/:toolId/',
    component: {
        render: () => import('#views/ToolDetail'),
        props: { variant: 'page' },
    },
    context: {
        title: 'Tool Detail',
    },
});

const helpMeChoose = customWrapRoute({
    parent: rootLayout,
    path: 'help-me-choose/',
    component: {
        render: () => import('#views/HelpChoosingPage'),
        props: {},
    },
    context: {
        title: 'Help Me Choose',
    },
});

const helpMeChooseForm = customWrapRoute({
    parent: rootLayout,
    path: 'help-me-choose/:categoryId/',
    component: {
        render: () => import('#views/HelpChoosingForm'),
        props: { variant: 'page' },
    },
    context: {
        title: 'Help Me Choose Questions',
    },
});

const results = customWrapRoute({
    parent: rootLayout,
    path: 'results/:submissionId?/',
    component: {
        render: () => import('#views/HelpChoosingPage/Results'),
        props: { variant: 'page' },
    },
    context: {
        title: 'Results',
    },
});

const contactUsForm = customWrapRoute({
    parent: rootLayout,
    path: 'contact-us/',
    component: {
        render: () => import('#views/ContactUsForm'),
        props: {},
    },
    context: {
        title: 'Contact Us Form',
    },
});

const requestDemoForm = customWrapRoute({
    parent: rootLayout,
    path: 'request-demo/',
    component: {
        render: () => import('#views/RequestDemo'),
        props: {},
    },
    context: {
        title: 'Request A Demo Form',
    },
});

const wrappedRoutes = {
    rootLayout,
    homeLayout,
    homeIndex,
    helpMeChoose,
    helpMeChooseForm,
    browseToolbox,
    toolDetail,
    results,
    contactUsForm,
    requestDemoForm,
};

export const unwrappedRoutes = unwrapRoute(Object.values(wrappedRoutes));

export default wrappedRoutes;

export type WrappedRoutes = typeof wrappedRoutes;
